import { dropRequestHeader, redactRecursively, transformJsonResponse } from '@alwaysmeticulous/redaction'
import type { RecorderMiddleware } from '@alwaysmeticulous/sdk-bundles-api'
import type { FullyAuthenticatedSessionUser } from '@omnea-app/fe-auth/session'

export const PRODUCTION_RECORDING_COOKIE = 'omnea_session_recording'
// 30 days (2,592,000 seconds)
export const PRODUCTION_RECORDING_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30

const PRODUCTION_RECORDING_ORGANISATION_IDS = new Set([
  'aeee20a4-ffec-4072-93d2-fa6f6c1251a5', // Omnea QA (EU)
  'b6add322-e387-40d4-9de6-b4056e3d0580', // PayrollCo 1 (EU)
  '8dc215f4-5ba5-43b6-9b2c-2db7472d0aba', // PayrollCo 2 [Editable] (EU)
])

type RecordingCandidate = Pick<FullyAuthenticatedSessionUser, 'email'> & {
  orgMetadata: Pick<FullyAuthenticatedSessionUser['orgMetadata'], 'organisationId'>
}

export const isProductionRecordingAllowed = (user: RecordingCandidate) =>
  PRODUCTION_RECORDING_ORGANISATION_IDS.has(user.orgMetadata.organisationId) && user.email.toLowerCase().endsWith('@omnea.co')

const EARLY_NETWORK_RECORDER_URL = 'https://snippet.meticulous.ai/record/v1/network-recorder.bundle.js'

// document.write keeps the recorder parser-blocking, so it wraps fetch before Next's deferred scripts run.
export const EARLY_NETWORK_RECORDER_GATE = `if (document.cookie.split('; ').includes('${PRODUCTION_RECORDING_COOKIE}=1')) document.write('<script src="${EARLY_NETWORK_RECORDER_URL}"><\\/script>')`

const REDACTED = 'redacted'

const redactJsonFields = (urlRegExp: RegExp, fields: ReadonlySet<string>) =>
  transformJsonResponse<unknown>({
    urlRegExp,
    transform: (data) =>
      typeof data === 'object' && data !== null
        ? redactRecursively(data, { redactString: (value, jsonPath) => (fields.has(jsonPath.at(-1) ?? '') ? REDACTED : value) })
        : data,
  })

export const PRODUCTION_RECORDING_MIDDLEWARE: RecorderMiddleware[] = [
  dropRequestHeader('Authorization'),
  // session.token is the signed JWT, whose payload carries the refresh token.
  redactJsonFields(
    /^https:\/\/[^/]+\/api\/auth\/session(\?|$)/,
    new Set(['token', 'courierToken', 'oneSchemaToken', 'pylonUserHash'])
  ),
  redactJsonFields(/^https:\/\/cognito-identity\.[^/]+\.amazonaws\.com\//, new Set(['AccessKeyId', 'SecretKey', 'SessionToken'])),
]
